// extracted by mini-css-extract-plugin
module.exports = {"contacts-section":"styles_contacts-section__17ZXi","contactsSection":"styles_contacts-section__17ZXi"};